<template>
  <div class="cs-resolved-cards-wrap">
    <div class="cs-resolved-cards">
      <div
        v-for="ref in references"
        :key="ref.id"
        class="cs-product-card"
        :style="{ opacity: ref._deselected ? 0.4 : 1 }"
      >
        <div class="cs-product-card__thumb-wrap">
          <img
            :src="effectiveUrl(ref)"
            class="cs-product-card__thumb"
            :alt="displayName(ref)"
          >

          <div
            v-if="ref._processing"
            class="cs-product-card__processing"
          >
            <span class="cs-product-card__spinner" />
            <span class="cs-product-card__processing-text">Processing…</span>
          </div>

          <div
            v-if="!ref._processing"
            class="cs-product-card__check"
            :class="{ 'cs-product-card__check--deselected': ref._deselected }"
            role="button"
            :aria-label="ref._deselected ? 'Reselect this product' : 'Deselect this product'"
            @click.stop="$emit('action', `toggle_product_selection:${ref.id}`)"
          >
            <span v-if="!ref._deselected">&#10003;</span>
          </div>
        </div>
        <div class="cs-product-card__name">
          {{ displayName(ref) }}
        </div>
      </div>
    </div>

    <div class="cs-resolved-cards__actions">
      <b-button
        variant="secondary"
        class="cs-resolved-cards__select-btn"
        @click="$emit('action', 'select_different_product')"
      >
        Select a different image
      </b-button>

      <b-dropdown
        v-if="autoCutRefs.length > 0"
        variant="link"
        no-caret
        right
        toggle-class="cs-resolved-cards__menu-toggle"
      >
        <template #button-content>
          <span
            class="cs-resolved-cards__dots"
            aria-label="More options"
          >⋮</span>
        </template>
        <template v-if="autoCutRefs.length === 1">
          <b-dropdown-header>{{ displayName(autoCutRefs[0]) }}</b-dropdown-header>
          <b-dropdown-item @click="$emit('action', `keep_background:${autoCutRefs[0].id}`)">
            Keep image background
          </b-dropdown-item>
        </template>
        <template v-else>
          <b-dropdown-item
            v-for="ref in autoCutRefs"
            :key="ref.id"
            @click="$emit('action', `keep_background:${ref.id}`)"
          >
            Keep background for {{ displayName(ref) }}
          </b-dropdown-item>
        </template>
      </b-dropdown>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AIChatResolvedProductCards',
  props: {
    references: {
      type: Array,
      required: true,
    },
  },
  computed: {
    autoCutRefs() {
      return this.references.filter((r) => Boolean(r.was_auto_cut) && !r.keep_background && !r._processing);
    },
  },
  methods: {
    effectiveUrl(ref) {
      if (ref.keep_background) return ref.original_url || ref.value;
      if (ref.was_auto_cut && ref.cutout_url) return ref.cutout_url;
      return ref.original_url || ref.value;
    },
    displayName(ref) {
      const name = ref.display_name;
      if (typeof name !== 'string' || name.trim() === '' || /^\d+$/.test(name.trim())) {
        return 'Attached image';
      }
      return name;
    },
  },
};
</script>

<style scoped>
.cs-resolved-cards-wrap {
  margin-top: 8px;
}
.cs-resolved-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.cs-product-card {
  display: inline-block;
  position: relative;
  margin: 4px;
}
.cs-product-card__thumb-wrap {
  position: relative;
}
.cs-product-card__thumb {
  max-height: 120px;
  border-radius: 6px;
  display: block;
}
.cs-product-card__processing {
  position: absolute;
  inset: 0;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
}
.cs-product-card__spinner {
  width: 24px;
  height: 24px;
  border: 3px solid rgba(0, 0, 0, 0.2);
  border-top-color: #4caf50;
  border-radius: 50%;
  animation: cs-card-spin 0.8s linear infinite;
}
.cs-product-card__processing-text {
  font-size: 11px;
  color: #333;
  font-weight: 600;
}
@keyframes cs-card-spin {
  to { transform: rotate(360deg); }
}
.cs-product-card__check {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: #4caf50;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  user-select: none;
}
.cs-product-card__check--deselected {
  background: #ccc;
}
.cs-product-card__name {
  text-align: center;
  font-size: 12px;
  margin-top: 2px;
}
.cs-resolved-cards__actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 10px;
}
.cs-resolved-cards__select-btn {
  /* Use existing project styling for secondary chat buttons */
}
.cs-resolved-cards__menu-toggle {
  padding: 4px 8px;
  background: transparent;
  border: none;
  line-height: 1;
}
.cs-resolved-cards__menu-toggle::after {
  display: none;
}
.cs-resolved-cards__dots {
  font-size: 22px;
  line-height: 1;
  color: #444;
}
</style>
